<template>
  <img :src="src | path" />
</template>

<script>
  import getPath from '@/components/mixin/getPath.js';

  export default {
    name: 'Vimg',

    mixins: [getPath],

    props: {
      src: {
        type: [String],
        default: ''
      }
    }
  };
</script>
